export default __webpack_public_path__ + "static/crossingGuard-7ebf7fa9673a2f94f66147ca8c14e8da.svg";